export default "__VITE_ASSET__C7kvDm7F__"